import React from 'react';
import { MessageCircle, Mail, Phone, Video } from 'lucide-react';
import { useUserEmail } from '../../context/UserAuthContext';

/**
 * TabHeader - Main tab selector for Communications page (Messages, Email, Calls, Meeting)
 */
const TabHeader = ({
  activeTab,
  onTabChange,
  className = ''
}) => {
  const userEmail = useUserEmail();
  const isCounterfind = (userEmail || '').toLowerCase() === 'counterfind@operatr.com';
  const isJaden = (userEmail || '').toLowerCase() === 'jaden@gmail.com';

  // Tab order:
  // - jaden@gmail.com: Email first, then Messages
  // - counterfind@operatr.com & everyone else: Messages first, then Email
  const tabs = isJaden
    ? [
        { id: 'email',    label: 'Email',    shortLabel: 'Email', icon: Mail },
        { id: 'messages', label: 'Messages', shortLabel: 'Msgs', icon: MessageCircle },
        { id: 'calls',    label: 'Calls',    shortLabel: 'Calls', icon: Phone },
        { id: 'meeting',  label: 'Meeting',  shortLabel: 'Meet', icon: Video },
      ]
    : [
        { id: 'messages', label: 'Messages', shortLabel: 'Msgs', icon: MessageCircle },
        { id: 'email',    label: 'Email',    shortLabel: 'Email', icon: Mail },
        { id: 'calls',    label: 'Calls',    shortLabel: 'Calls', icon: Phone },
        { id: 'meeting',  label: 'Meeting',  shortLabel: 'Meet', icon: Video },
      ];

  return (
    <div className={`flex border-b border-gray-400/20 bg-black overflow-x-auto ${className}`}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            data-testid={`tab-${tab.id}`}
            className={`flex-1 min-w-[80px] py-3 md:py-4 px-2 md:px-6 text-xs md:text-sm font-semibold transition-all whitespace-nowrap ${
              isActive
                ? 'text-white border-b-2 border-gray-300'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            <Icon className="inline mr-1 md:mr-2" size={16} />
            <span className="hidden sm:inline">{tab.label}</span>
            <span className="sm:hidden">{tab.shortLabel}</span>
          </button>
        );
      })}
    </div>
  );
};

export default TabHeader;
